import tmhRequest from '@/config/tmhRequest'


export default {
  searchListStoreService: function ( data) {
    return tmhRequest({
      url: '/project/tmh/storeservice/searchliststoreservice',
      method: 'post',
      params: data,
    })
  },

  searchListUpgradeStoreService: function ( data) {
    return tmhRequest({
      url: '/project/tmh/storeservice/searchlistupgradestoreservice',
      method: 'post',
      params: data,
    })
  },

  searchNoPlusStoreService: function ( data) {
    return tmhRequest({
        url: '/project/tmh/storeservice/searchnoplusstoreservice',
      method: 'post',
      params: data,
    })
  },

  searchStoreServiceCount: function ( data) {
    return tmhRequest({
        url: '/project/tmh/storeservice/searchstoreservicecount',
      method: 'post',
      data: data,
    })
  },

  searchStoreServiceByPage: function ( data) {
    return tmhRequest({
        url: '/project/tmh/storeservice/searchstoreservicebypage',
      method: 'post',
      data: data,
    })
  },

  editStoreServiceSort: function ( data) {
    return tmhRequest({
        url: '/project/tmh/storeservice/editstoreservicesort',
      method: 'post',
      data: data,
    })
  },

  initStoreService: function (data) {
    return tmhRequest({
      url: '/project/tmh/storeservice/initstoreservice',
      method: 'post',
      params: data,
    })
  },
  multiEditStoreService: function (data) {
    return tmhRequest({
      url: '/project/tmh/storeservice/multieditstoreservice',
      method: 'post',
      data: data,
    })
  },
}


// WEBPACK FOOTER //
// ./src/api/tmh/project/storeservice.js